import React from 'react';

const SupportTypingIndicator = ({ label }) => (
  <div className="support-typing" role="status" aria-live="polite">
    <span className="support-typing-label">{label}</span>
    <span className="support-typing-dots" aria-hidden="true">
      <span className="support-typing-dot" />
      <span className="support-typing-dot" />
      <span className="support-typing-dot" />
    </span>
  </div>
);

export default SupportTypingIndicator;
